import { defineComponent, PropType } from '@vue/composition-api';
import { get } from 'lodash-es';
import { AcoFormData, FullNormalFormData, CALLVIDEOEDITSCENE, PRECHECK_RESULT_CODE_MAP } from '@tt4b/ttam-enums';
// import { trackEvent } from '@/track/utils';

// 组装需要的数据
const getAuditInfo = (currentMaterialCheckResult, scene) => {
  // 埋点
  // trackEvent('edit_the_video_click', {
  //   Source: scene,
  //   problems:
  //     scene === 'reject'
  //       ? String(currentMaterialCheckResult.disapprovalCode)
  //       : _.get(currentMaterialCheckResult, `[0].tagIds`, [])?.toString(),
  // });

  // 拒审的时候传的数据
  if (scene === 'reject') {
    return {
      auditInfo: {
        type: CALLVIDEOEDITSCENE.REJECT,
        rules: [String(currentMaterialCheckResult.disapprovalCode)], // 拒审code
        auditCheckBlackBorder: [],
      },
    };
  }

  // 创编的时候传递的数据
  return {
    auditInfo: {
      type: CALLVIDEOEDITSCENE.CREATE,
      rules: get(currentMaterialCheckResult, '[0].tagIds', []),
      auditCheckBlackBorder: JSON.parse(
        get(currentMaterialCheckResult, `[0].details.${PRECHECK_RESULT_CODE_MAP.VIDEO_SIZE}`, '[]')
      ),
    },
  };
};

const name = 'ttam-video-edit';

export default defineComponent({
  name,
  props: {
    creativeData: {
      type: Object as PropType<AcoFormData & FullNormalFormData>,
      default: () => ({}),
    },
    currentMaterialCheckResult: {
      type: [Array, Object],
      default: () => ({}),
    },
    // 使用场景，区分是在创编中使用，还是在拒审页面使用
    scene: {
      type: String,
      default: 'create',
    },
  },
  setup(props, { emit }) {
    const hangleVideoEdit = () => {
      emit('edit-video', {
        data: getAuditInfo(props.currentMaterialCheckResult, props.scene),
        vid: props.creativeData?.videoInfo?.vid,
      });
    };

    return {
      name,
      hangleVideoEdit,
    };
  },
});
